import axiosInstance from "./axiosInstance";

const LAB_INTERNALS_BASE = "/lab-internals";

// Faculty APIs
export const getFacultyLabInternals = async () => {
  const response = await axiosInstance.get(`${LAB_INTERNALS_BASE}/faculty`);
  const raw = response.data?.data ?? response.data;
  return Array.isArray(raw) ? raw : [];
};

export const getFacultyLabInternalDetails = async (labId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/faculty/${labId}`
  );
  return response.data;
};

export const triggerFacultyLabEvaluation = async (labId) => {
  const response = await axiosInstance.post(
    `${LAB_INTERNALS_BASE}/faculty/${labId}/evaluate`
  );
  return response.data;
};

export const triggerManualEvaluation = async (studentLabIds) => {
  const response = await axiosInstance.post("/evaluation/manual", {
    studentLabIds,
  });
  return response.data;
};

export const getFacultyStudentEvaluation = async (labId, studentLabId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/faculty/${labId}/student/${studentLabId}`
  );
  return response.data;
};

export const getFacultyAllowedQuestions = async (labId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/faculty/${labId}/questions`
  );
  return response.data;
};

/** Keys from backend/config/evaluationConfig.json → sets (SET_1, …) */
export const getFacultyEvaluationSetKeys = async () => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/faculty/evaluation-set-keys`
  );
  const keys = response.data?.data?.setKeys;
  return Array.isArray(keys) ? keys : [];
};

export const setFacultyAllowedQuestions = async (labId, questions) => {
  console.log('setFacultyAllowedQuestions called with:', labId, questions);
  const response = await axiosInstance.post(
    `${LAB_INTERNALS_BASE}/faculty/${labId}/questions`,
    { questions }
  );
  console.log('setFacultyAllowedQuestions response:', response.data);
  return response.data;
};

// Student APIs
export const getStudentLabInternalDashboard = async (labId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/student/${labId}`
  );
  return response.data;
};

export const getStudentLabInternals = async () => {
  const response = await axiosInstance.get(`${LAB_INTERNALS_BASE}/student/labs`);
  return response.data.data;
};

export const getStudentLabQuestions = async (labId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/student/${labId}/questions`
  );
  return response.data.data;
};

export const lockStudentLabQuestions = async (labId, payload) => {
  const response = await axiosInstance.post(
    `${LAB_INTERNALS_BASE}/student/${labId}/lock-question`,
    payload
  );
  return response.data;
};

export const getStudentsLockedQuestions = async (labId) => {
  const response = await axiosInstance.get(
    `${LAB_INTERNALS_BASE}/student/${labId}`
  );
  return response.data;
};

export const submitStudentTest = async (labId, payload) => {
  const response = await axiosInstance.post(
    `${LAB_INTERNALS_BASE}/student/${labId}/submit-test`,
    payload
  );
  return response.data;
};

export const deleteFacultyLabInternal = async (labId) => {
  const response = await axiosInstance.delete(
    `${LAB_INTERNALS_BASE}/faculty/${labId}`
  );
  return response.data;
};